import DashboardAvatarIcon from "@/components/icons/dashboard-avatar";
import DashboardAddressIcon from "@/components/icons/dashboard-address";
import DashboardFavouriteIcon from "@/components/icons/dashboard-favourite.";
import DashboardordersIcon from "@/components/icons/dashboard-orders";

export const dashboardTabs = [
  {
    icon: <DashboardAvatarIcon className="max-sm:size-4 size-6" />,
    label: "Account",
    target: "/user",
  },
  {
    icon: <DashboardAddressIcon className="max-sm:size-4 size-6" />,
    label: "Address",
    target: "/user/address",
  },
  {
    icon: <DashboardordersIcon className="max-sm:size-4 size-6" />,
    label: "Orders",
    target: "/user/orders",
  },
  {
    icon: <DashboardFavouriteIcon className="max-sm:size-4 size-6" />,
    label: "Favourite",
    target: "/user/favourite",
  },
];
